import React from 'react'

import PropTypes from 'prop-types'
import validate from 'validate.js'

import Button from '../../../../shared_components/Button'
import ClientInviteActions from '../../actions/ClientInviteActions'
import FuneralHomeClientPrivacyNoticeModal from '../../../../shared_components/FuneralHomeClientPrivacyNoticeModal'
import Forms from '../../../../shared_components/forms'
import HouseholdLearnMoreModal from './HouseholdLearnMoreModal'
import PrivacyLearnMore from './PrivacyLearnMore'
import usePasswordValidation from '../../../../shared_components/hooks/usePasswordValidation'

import {If} from '../../../../shared_components/deprecated/IfFlag'
import {trimString} from '../../../../lib/textTools'

import './clientInviteForm.scss'

class ClientInviteFormInner extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      formErrors: [],
      passwordErrors: [],
      processing: false
    }
    this.emailValidator = this.emailValidator.bind(this)
    this.resetAndSubmit = this.resetAndSubmit.bind(this)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.errors.length > 0)
      this.setState({processing: false})
  }

  resetAndSubmit() {
    this.setState({processing: true})

    if (this.props.errors.length > 0)
      this.props.resetEmailError()

    const formErrors = this.refs.form.validate()

    if (formErrors.length > 0) {
      this.setState({formErrors})
      this.setState({processing: false})
    }

    this.formSubmit()
  }

  async formSubmit() {
    const errors = this.refs.form.validate()

    if (errors.length === 0) {
      const formData = this.refs.form.formData()

      // Check password against HIBP and weak password list before submitting
      const serverErrors = await this.props.validatePassword(formData.password)
      if (serverErrors.length > 0) {
        this.setState({passwordErrors: [{name: 'password', errors: serverErrors}], processing: false})
        return
      }

      this.setState({formErrors: [], passwordErrors: []})
      ClientInviteActions.submitActivationForm(formData, this.props.params.clientInviteId)
    }
  }

  emailValidator(name, data) {
    const error = validate.single((trimString(data.email)), {presence: true, email: true})

    if (error)
      return {name: 'email', errors: [`Email ${error}`]}
  }

  render() {
    const {clientInvite} = this.props
    const nameText = clientInvite.firm_type === 'funeral_home' ?
      clientInvite.firm_name :
      clientInvite.advisor_name

    const privacyText = `Your Everplan comes courtesy of ${nameText}. In order to help you progress in your planning, certain information about how you are using Everplans may be shared with ${nameText}.`

    return (
      <div className='client-invite-form row-wrapper-sb'>
        <div>
          <h1>Activate your Everplans account</h1>
          <Forms.Form ref='form' errors={[...this.props.errors, ...this.state.passwordErrors]}>
            <Forms.Input
              name='email'
              className='email'
              label='Email address'
              validator={this.emailValidator}
              defaultValue={clientInvite.email}
              readonly=''
            />
            <Forms.DateInput label='Date of birth' ref='dob' name='birthdate' validator={Forms.Validators.birthdateValidator} />
            <Forms.ZipOrCountry name='zipOrCountry' />
            <Forms.Password name='password' type='password' label='Password' />
            <Forms.ServiceTerms name='agreement_accepted' />
            <div className='button-group'>
              <Button loading={this.state.processing || this.props.validating} onClick={this.resetAndSubmit} className='btn btn-primary' ref='button'>Activate account</Button>
              <If flag={this.state.formErrors.length > 0 || this.props.errors.length > 0}>
                <Forms.Errors errors={['Please review the errors above.']} />
              </If>
            </div>
          </Forms.Form>
        </div>
        <div className='privacy-box'>
          <div className='privacy-content'>
            <h4>Privacy notice{clientInvite.household ? 's' : ''}</h4>
            {
              clientInvite.household ?
                <ul className='privacy-blurbs'>
                  <li>
                    {privacyText}
                    <PrivacyLearnMore data={clientInvite} />
                  </li>
                  <li>
                    Your subscription is for a Household Everplan, to be shared with {clientInvite.hp_partner_name}. {clientInvite.hp_partner_first_name} is a co-administrator, and will be able to view, edit, and manage all parts of the Everplan that you have been provided.
                    <HouseholdLearnMoreModal data={clientInvite} />
                  </li>
                </ul> :
                <>
                  <p>{privacyText}</p>
                  {
                    clientInvite.firm_type === 'funeral_home' ?
                      <FuneralHomeClientPrivacyNoticeModal linkText='Learn more' /> :
                      <PrivacyLearnMore data={clientInvite} />
                  }
                </>
            }
          </div>
        </div>
      </div>
    )
  }
}

ClientInviteFormInner.propTypes = {
  clientInvite: PropTypes.shape({
    advisor_name: PropTypes.string,
    email: PropTypes.string,
    editable_item_ids: PropTypes.arrayOf(PropTypes.string),
    firm_name: PropTypes.string,
    firm_type: PropTypes.string,
    household: PropTypes.bool,
    hp_partner_first_name: PropTypes.string,
    hp_partner_name: PropTypes.string
  }),
  errors: PropTypes.arrayOf(PropTypes.string),
  params: PropTypes.shape({
    clientInviteId: PropTypes.string
  }),
  resetEmailError: PropTypes.func,
  validatePassword: PropTypes.func,
  validating: PropTypes.bool
}

const ClientInviteForm = props => {
  const {validatePassword, validating} = usePasswordValidation()
  return <ClientInviteFormInner {...props} validatePassword={validatePassword} validating={validating} />
}

export default ClientInviteForm
